import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/axelerate-logo-purple.svg'


const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center rounded bg-background" }
const _hoisted_2 = { class: "flex flex-col bg-white lg:shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-lg w-full max-w-md" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"pt-5 pb-5\"><img src=\"" + _imports_0 + "\" alt=\"login logo\" class=\"w-5/12 lg:pb-5\"><div class=\"flex justify-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-1/4 w-1/4 text-green-400\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div></div><div class=\"flex justify-center\"><span class=\"font-bold self-start text-xl sm:text-2xl text-gray\"> Payment Successful </span></div><div class=\"flex justify-center\"><span class=\"mt-5 mb-3 text-black text-sm overflow-clip tracking-normal text-left\"></span></div>", 3)
const _hoisted_6 = { class: "flex w-full mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = () => _ctx.router.push('/')),
            class: "flex items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-primary rounded-full py-2 w-full transition duration-150 ease-in h-14 btn-submit"
          }, " Go to Home ")
        ])
      ])
    ])
  ]))
}